import { useState } from "react";
import { Email } from "../Email/Email";
import "./styles.css";
import { Form } from "../Form/Form";
import { useTranslation } from "react-i18next";
import { NameForm } from "../NameForm/NameForm";
import { useFlowID } from "../../context/FlowIDContext";

export const InfoCollection = ({ updateEmail, questionsData, onComplete }) => {
  const { i18n } = useTranslation();
  const flowId = useFlowID();
  const [infoStep, setInfoStep] = useState(0);
  const [userInfo, setUserInfo] = useState({ atStore: flowId === 1 });

  const loadNextStep = (data) => {
    if (questionsData.length < 1 && infoStep === 1) {
      onComplete({ ...userInfo, ...data, lang: i18n.language });
    } else {
      setUserInfo((prevData) => ({ ...prevData, ...data }));
      setInfoStep((prevValue) => prevValue + 1);
    }
  };

  return (
    <>
      {infoStep === 0 && <NameForm updateUserInfo={loadNextStep} />}
      {infoStep === 1 && (
        <Email updateEmail={updateEmail} updateUserInfo={loadNextStep} />
      )}
      {infoStep === 2 && (
        <Form formData={questionsData} onComplete={loadNextStep} />
      )}
    </>
  );
};
